import { isRef, ref, watch } from 'vue-demi';

function isVisible(element) {
  return element.getClientRects().length > 0;
}

function useElevation(element, trigger) {
  const elementRef = isRef(element) ? element : ref(element);
  const triggerRef = isRef(trigger) ? trigger : ref();
  // Functions
  function getPageElevations(currentElement) {
    return [...document.body.querySelectorAll('*')].filter(isVisible).filter(element => !element.isEqualNode(currentElement)).map(element => getComputedStyle(element)).map(style => Number(style.zIndex)).filter(zIndex => !isNaN(zIndex));
  }
  function setElementElevation(element) {
    element.style.zIndex = String(Math.max(0, ...getPageElevations(element)) + 1);
  }
  // Effects
  watch([elementRef, triggerRef], _ref => {
    let [element] = _ref;
    if (element) {
      setElementElevation(element);
    }
  }, {
    immediate: true
  });
}

export { useElevation as u };
